import { UserBasic } from "../account/user-basic.model";
import { Payment } from "../payments/payment.model";
import { EventBookingBasic } from "./event-booking-basic.model";

export interface EventBookingDetailed extends EventBookingBasic{
    ticketTypes: TicketTypes[];
    paypalPaymentId: string;
    totalDue: number;
    totalPaid: number;
    originalUserId: number;
    originalUser: UserBasic;
    user: UserBasic;
    payment?: Payment
}

export enum TicketTypes {
    player,
    monster,
    Staff,
    Meal
}